import { render, staticRenderFns } from "./BloodTypeTable.vue?vue&type=template&id=429ee4d8&"
import script from "./BloodTypeTable.vue?vue&type=script&lang=js&"
export * from "./BloodTypeTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports